import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { MfgUnitDimension } from "@/lib/mfg-boms";
import type { MfgTreeNode } from "./useMfgTree";

export function MfgDimensionsForm({ materials, dims, onChange }: {
  materials: MfgTreeNode[];
  dims: Record<number, MfgUnitDimension>;
  onChange: (materialId: number, dim: MfgUnitDimension) => void;
}) {
  if (materials.length === 0) return null;
  return (
    <div className="space-y-3">
      {materials.map((m) => {
        const d = dims[m.item.mfgItemId] ?? { materialMfgItemId: m.item.mfgItemId, width: m.item.material?.width ?? 0, length: m.item.material?.length ?? 0, thickness: m.item.material?.thickness ?? 0, unitOfMeasureCode: m.item.material?.unitOfMeasureCode ?? m.item.unitOfMeasureCode ?? "" };
        const set = (patch: Partial<MfgUnitDimension>) => onChange(m.item.mfgItemId, { ...d, ...patch });
        return (
          <div key={m.item.mfgItemId}>
            <Label className="text-sm font-semibold">{m.item.name} dimensions</Label>
            <div className="grid grid-cols-3 gap-2">
              <Input type="number" value={d.width} onChange={(e) => set({ width: Number(e.target.value) })} placeholder="Width" />
              <Input type="number" value={d.length} onChange={(e) => set({ length: Number(e.target.value) })} placeholder="Length" />
              <Input type="number" value={d.thickness} onChange={(e) => set({ thickness: Number(e.target.value) })} placeholder="Thickness" />
            </div>
          </div>
        );
      })}
    </div>
  );
}
